// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {TrackingState} from 'redux/uiState/tracking/TrackingState';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {SET_BEGIN_CHECKOUT} from 'redux/uiState/tracking/actions';
import {trackingState} from 'redux/uiState/UiState';

const initState: TrackingState = {
  beginCheckout: true,
};

const actionCreators: ActionHandlers<TrackingState> = {
  [PURE(SET_BEGIN_CHECKOUT)]: (state: TrackingState, action) => ({
    ...state,
    ...action,
  }),
};

export const trackingReducer: Reducer<TrackingState> =
  // $FlowIgnore
  createReducerUsingActionHandlers<TrackingState>(initState, actionCreators);

export const getBeginCheckout: Selector<boolean> = createSelector(
  trackingState,
  (state: TrackingState) => state.beginCheckout
);
